import api from '../../api'
import Vue from 'vue'

const state = {
  shoppingSum: 0
}
const mutations = {
  changeShoppingCar (state, num) {
    state.shoppingSum = num
  }
}
const actions = {
  getCartCount (context) {
    api.getCartCount({ course_belong: '质心灵动量' }).then(r => {
      if (r.data.code === 1) {
        const sum = r.data.data.cart_count
        context.commit('changeShoppingCar', sum)
      }
    })
  },
  addCar (context, data) {
    let json = {
      goods_ids: data.goodsIds,
      // goods_type: data.goodsType,
      course_belong: '质心灵动量'
    }
    if (data.otherParams) {
      json = Object.assign(json, data.otherParams)
    }
    api.addCart(json).then(r => {
      if (r.data.code === 1) {
        data.callback && data.callback()
        context.commit('changeShoppingCar', r.data.data.cart_count)
      } else {
        data.errorBack && data.errorBack(r)
        Vue.prototype.$message.warning(r.data.message)
      }
    })
  }
}
export default {
  state,
  mutations,
  actions
}
